<template>
  <div class="DublabGallery">
    <flickity v-if="hasImages" class="flickity" ref="flickity" :options="flickityOptions" :key="id">
      <div
        v-for="(image, i) in images"
        :class="['slide-container', size, { extend }]"
        :key="i"
      >
        <div class="slide" :style="{ backgroundImage: 'url(' + image.sizes.medium_large + ')' }"></div>
      </div>
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'
import 'flickity/css/flickity.css'

export default {
  name: 'DublabGallery',
  props: {
    images: Array,
    fit: Boolean,
    extend: Boolean
  },
  components: { Flickity },
  data () {
    return {
      flickityOptions: {
        autoPlay: true,
        pauseAutoPlayOnHover: false,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left'
      }
    }
  },
  computed: {
    hasImages () {
      return this.images && this.images.length
    },
    size () {
      return this.fit ? 'size--fit' : 'size--viewport'
    },
    id () {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
    }
  }
}
</script>

<style scoped>
.slide-container.size--fit {
  width: 100%;
  padding-left: 2px;
  margin-right: 2rem;
}

.slide-container.size--viewport { 
  padding-left: 2px;
  padding-right: 2rem;
  width: 40vw; 
}

.slide-container.size--viewport.extend {
  padding-left: 2rem; 
  padding-right: 2px;
}

.slide {
  border-radius: var(--br1);
  background-size: cover;
  background-position: center;
  padding-top: 62.5%;
  overflow: hidden;
  width: 100%;
}

@media (max-width: 1280px) {
  .slide-container.size--viewport { 
    width: 46vw; 
  }
}

@media (max-width: 1000px) {
  .slide-container.size--viewport { 
    width: 64vw; 
  }
}

@media (max-width: 600px) {
  .slide-container.size--viewport { 
    width: 32rem; 
  }
}
</style>